module.exports = __webpack_public_path__ + "img/Chandani.87b9b4f4.svg";